module.exports = __webpack_public_path__ + "img/advantage1.364b038c.png";